import { render, staticRenderFns } from "./priSettingsConfigurablePri.vue?vue&type=template&id=8795032c"
import script from "./priSettingsConfigurablePri.vue?vue&type=script&lang=js"
export * from "./priSettingsConfigurablePri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports